import $ from 'jquery';
$('.item.menu').click(function() {
	$('.sticky-menu').toggleClass('is-open-right has-transition-push has-position-right');
	$('body').toggleClass('off-canvas-open');
});

$('.menu-offcanvas__close, .js-off-canvas-overlay').click(function() {
	$('.sticky-menu').removeClass('is-open-right is-open-left has-transition-push has-position-right has-position-left');
	$('body').removeClass('off-canvas-open');
});
